<div class="container-fluid">
  <div class="row justify-content-between border-bottom">
    <div class="col-9 pl-2">
     <ng-container>
      <h3 mat-dialog-title class="inventory-adjustment-title">{{data?.fileName}}</h3>
     </ng-container>
    </div>
    <div class="col-3 pr-1 text-right cursor-pointer">
      <mat-icon (click)="closeDialog()">clear</mat-icon>
    </div>
 </div>
  <mat-dialog-content class="mat-typography inventory-view-dialog">
    <div class="row py-2 inventory-report-popup-list">
      <shtiks-list-updated SelectableRows="false" investigateItem="false" pivotedItem="false" allowAction="false" [CustomStyleClass]="'reports-popup'"
        [EnableAction]="false" [MasterColumns]="columnsToDisplay" [GridData]="data?.gridData" [hasMoreHeader]="false">
      </shtiks-list-updated>
    </div>
  </mat-dialog-content>

</div>
